import React, { createContext, useState, useContext } from 'react';

const TreatmentContext = createContext(null);

export const useTreatment = () => {
  const context = useContext(TreatmentContext);
  if (!context) {
    throw new Error('useTreatment must be used within a TreatmentProvider');
  }
  return context;
};

export const TreatmentProvider = ({ children }) => {
  const [currentPatient, setCurrentPatientState] = useState(null);
  const [lastRecommendation, setLastRecommendationState] = useState(null);

  const setCurrentPatient = (patient) => {
    setCurrentPatientState(patient);
  };

  const clearCurrentPatient = () => {
    setCurrentPatientState(null);
  };

  const setLastRecommendation = (recommendation) => {
    setLastRecommendationState(recommendation);
  };

  const clearLastRecommendation = () => {
    setLastRecommendationState(null);
  };

  const value = {
    currentPatient,
    setCurrentPatient,
    clearCurrentPatient,
    lastRecommendation,
    setLastRecommendation,
    clearLastRecommendation,
  };

  return (
    <TreatmentContext.Provider value={value}>
      {children}
    </TreatmentContext.Provider>
  );
};

export default TreatmentContext;
